import axios from 'axios';
import { API_URL } from '../env';
import { normalize } from '../services/helpers';

export const create = async (opponentId) => {
  await axios.post(`${API_URL}/games`, {
    opponent_id: opponentId,
  });
};

/** Deletes the games: all of them, or none if any isn't the player's. */
export const destroyMany = async (gameIds) => {
  await axios.post(`${API_URL}/games/delete`, { ids: gameIds });
};

export const all = async () => {
  const response = await axios.get(`${API_URL}/games`, { params: { include: ['users', 'board'] } });

  return normalize(response.data);
};

export const get = async (id) => {
  const response = await axios.get(`${API_URL}/games/${id}`, {
    params: {
      include: [
        'activePokemon',
        'benches',
        'discardPiles',
        'deckPiles',
        'gameTurn',
        'gamePlayers',
        'hands',
        'prizePiles',
        'users',
        'options',
      ],
    }
  });

  return normalize(response.data);
};

/** The activity log, oldest first, as this player may see it. */
export const log = async (id) => {
  const response = await axios.get(`${API_URL}/games/${id}/log`);

  return response.data.data;
};

export const setDeck = async (id, deckId) => {
  const response = await axios.patch(`${API_URL}/games/${id}/set-deck`, {
    deck_id: deckId,
  });

  return normalize(response.data);
};

export const pass = async (id) => {
  const response = await axios.patch(`${API_URL}/games/${id}/pass`);

  return normalize(response.data);
};

export const retreat = async (id, benchPosition, energyAttachmentIds) => {
  const response = await axios.patch(`${API_URL}/games/${id}/retreat`, {
    bench_position: benchPosition,
    energyAttachmentIds,
  });

  return normalize(response.data);
};
